<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="角色编号">
            <a-input :disabled="editStatus" v-decorator="['roleNo', rules.roleNo]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="角色名称">
            <a-input v-decorator="['roleName', rules.roleName]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="角色类型" >
            <a-select
                v-decorator="['roleType',rules.roleType]"
                :options="ruleTypeOptions"
                @change="handleChange"
            >
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" v-if="isDeptShow">
          <a-form-item label="所属部门">
            <a-tree-select
                v-decorator="['belongDeptId',rules.belongDeptId]"
                allow-clear
                show-search
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="deptList"
                :treeDefaultExpandAll="false"
                :treeDefaultExpandedKeys.sync="defaultExpandedKeys"
                :filterTreeNode="filterTreeNodeOption"
                :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="是否使用">
            <a-switch
                v-decorator="['isUse',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否系统角色">
            <a-switch
                :disabled="true"
                v-decorator="['isSystem',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="是否可见手机号">
            <a-switch
                v-decorator="['isShowMobile',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-form-item label="备注"
                     :label-col="{ span: 4 }"
                     :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['remark']"></a-textarea>
        </a-form-item>
      </a-row>

      <!-- qf12 -->
      <!-- <a-tabs>
        <a-tab-pane v-for="(item,index) in menuList" :key="item.key" :tab="item.name" :forceRender="false">
          <menuChildTable
              :ref="'menuChildTable'+index"
              :listArr="item.children"
              :row-id="rowId"
          ></menuChildTable>
        </a-tab-pane>
      </a-tabs> -->

      <el-tabs v-model="activeKey" class="tabsClass">
        <el-tab-pane  v-for="(item,index) in menuList" :key="index" :label="item.name">
          <menuChildTable
              :ref="'menuChildTable'+index"
              :listArr="item.children"
              :row-id="rowId"
          ></menuChildTable>
        </el-tab-pane>
      </el-tabs>

      <a-row style="margin-top: 30px">
        <a-col :span="24">
          <a-form-item label="数据权限" :label-col="{ span: 2 }"
                       :wrapper-col="{ span: 22 }">
            <a-select
                v-decorator="['adminType',rules.adminType]"
                :options="adminTypeOptions"
                @change="handleChange"
            >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-tabs v-if="adminType === 3">
        <a-tab-pane key="1" tab="管理部门" :forceRender="true">
          <a-tree
              v-model="checkedKeys"
              :checkable="true"
              :selectable="false"
              :autoExpandParent="true"
              :expanded-keys="expandedKeys"
              :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
              :tree-data="deptList"
              @expand="onExpand"
          />
        </a-tab-pane>
      </a-tabs>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>

</template>

<script>
import {formMixin, fmt, XEUtils} from '@/utils/common/FormBase'
import menuChildTable from "@/pages/web/comm/roleManage/menuChildTable";
//接口API
import {dataApi} from '@/services/comm/roleManage';


/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    roleNo: {
      rules: [{required: true, whitespace: true, message: "请输入角色编号"}]
    },
    roleName: {
      rules: [{required: true, whitespace: true, message: "请输入角色名称"}]
    },
    roleType: {
      rules: [{required: true, message: "请选择角色类型"}]
    },
    belongDeptId: {
      rules: [{required: true, message: "请选择所属部门"}]
    },
    adminType: {
      rules: [{required: true, message: "请选择管理员状态"}]
    },
    defaultExpandedKeys:[]
  };
}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  let list = await dataApi.getMenuList('');
  list.data.forEach(e => {
    if (entity.menuIdList) {
      e.checked = !!entity.menuIdList.filter(v => {
        return v === e.menuId
      }).length
    } else {
      e.checked = false
    }
  })

  this.menuList = XEUtils.toArrayTree(list.data.map((val) => {
    return Object.assign(val, {
      title: val.name,
      key: val.menuId,
    })
  }), {
    key: 'key',
    parentKey: 'parentId',
    children: 'children'
  });

  this.editStatus = !!entity.roleNo;//是否可编辑用户账号
  this.createUserId = entity.createUserId;
  this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isUse: true,
    isShowMobile:false,
    isSystem: false
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  // 新增部门的情况 admin账户的权限 没有更新 这时候取最多的部门 【总部门>admin已存的部门】
  // 根本原因：树不更新 依旧是全选（因为有1 最高层捷瑞数字 所以树就以为是全选）
  // ! (是admin账号的情况并且有新部门,取所有部门) => 取已存数据
  this.adminType = entity.data.adminType
  if(entity.data.roleType === 2){
    this.isDeptShow = true;
  }else {
    this.isDeptShow = false;
  }
  if (!(entity.data.roleId == 2 && entity.data.roleNo == 'admin' && this.checkedKeys.length > entity.data.deptIdList.length)) {
    this.checkedKeys = entity.data.deptIdList || [];
  }
  return fmt.formatFormLoad(entity, null, ['isUse', 'isSystem','isShowMobile']);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  this.adminTypeOptions = [{
    value: 0,
    label: '查看所有'
  }, {
    value: 1,
    label: '只能查看自己的数据'
  }, {
    value: 2,
    label: '查看所属部门（含子部门）的数据'
  }, {
    value: 3,
    label: '查看所管理部门（含子部门）的数据'
  }]
  this.ruleTypeOptions = [{
    value: 1,
    label: '通用角色'
  }, {
    value: 2,
    label: '部门角色'
  }]
  let deptList = await dataApi.getDeptList();
  this.deptList = XEUtils.toArrayTree(deptList.data, {
    key: 'deptId',
    parentKey: 'parentId',
    children: 'children'
  })
  //默认所属部门只展开一级
  this.defaultExpandedKeys = this.deptList.map(val => {
    //默认只展开一级
    if( val.deptId == 1 ){ //已确定测试、正式系统最大一层deptId都是1
      return val.deptId
    }
  })

  //所有的deptId 默认选空
  //this.checkedKeys = deptList.data.map((item) => item.deptId);
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {

  let allCheckKeys = []
  vm.menuList.forEach((e, i) => {
    let obj = vm.$refs[`menuChildTable${i}`][0].getFinallyData();
    if (obj.parentsId.length) {
      allCheckKeys.push(e.menuId);
      allCheckKeys = allCheckKeys.concat(obj.parentsId, obj.childrenIds);
    }
  })
  // if (!allCheckKeys.length) {
  //   throw '请至少选择一个查看的菜单权限';
  // }
  entities.deptIdList = this.checkedKeys;
  entities.roleId = vm.keyId;
  entities.menuIdList = allCheckKeys;
  entities.createUserId = vm.createUserId;
  entities.createDate = vm.createDate;
  return await dataApi.saveFormDetail(entities);
}

/**
 * 树选择搜索
 * */
function filterTreeNodeOption(input, treeNode) {
  return treeNode.data.props.title.includes(input)
}

/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    menuChildTable
  },
  data() {
    return {
      editStatus: false,
      menuList: [],
      adminTypeOptions: [],
      ruleTypeOptions: [],
      deptList: [],
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      adminType: 0,
      isDeptShow: false,
      activeKey: ''
    }
  },
  mounted() {
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    filterTreeNodeOption,
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    handleChange(value) {
      this.adminType = value
      if(value === 2){
        this.isDeptShow = true;
      }else {
        this.isDeptShow = false;
      }
    }
  },
};
</script>

<style scoped lang="less">
</style>
